module.exports = __webpack_public_path__ + "static/media/moment07.9b110975.webp";